/** The small upper-case line that labels a block without being a heading.
 *
 * Nocturne uses it everywhere a card needs to say what it is — "shown once",
 * "racing line · lap 7", "new token" — at 10px with wide tracking, in the
 * accent by default. It is deliberately not an `h*`: a kicker names the thing
 * beside it, it does not open a section, and putting it in the heading
 * outline would make every card a document chapter.
 */

import type { ReactNode } from 'react';

export interface KickerProps {
  children: ReactNode;
  /** `muted` drops the accent for the neutral ramp — used where the kicker
   *  is a timestamp or a severity rather than a title. */
  tone?: 'accent' | 'muted';
  /** Any colour token, for the one case the design colours a kicker by
   *  severity. Pass a `var(--color-…)`, never a literal. */
  color?: string;
  className?: string;
}

export function Kicker({ children, tone = 'accent', color, className }: KickerProps) {
  const classes = ['card-kicker', tone === 'muted' ? 'card-kicker-muted' : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <span className={classes} style={color ? { color } : undefined}>
      {children}
    </span>
  );
}

export default Kicker;
